import moment from 'moment'
import {chain} from 'lodash'
import * as dateLocale from 'date-fns/locale'

import React from 'react'
import { makeStyles, withStyles} from 'external/material'
import Box from '@mui/material/Box'
import Hidden from '@mui/material/Hidden'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import DatePicker from "react-datepicker"
import {faCalendarAlt} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"

import "react-datepicker/dist/react-datepicker.css"

class DateInput extends React.Component {
  render () {
    return (
      <div className="date-input" onClick={this.props.onClick}>
        <FontAwesomeIcon icon={faCalendarAlt} />
        {this.props.value}
      </div>
    )
  }
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    padding: '0 20px',
    overflow: 'hidden',
  },
  label: {
    padding: '20px 0'
  },
  comments: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflowY: 'auto',
    '& textarea': {
      flexGrow: 1,
      resize: 'none'
    }
  },
  buttons: {
    padding: '20px 0',
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    }
  },
  cancel: {
    width: '120px',
    marginRight: '20px',
    boxShadow: 'none',
    [theme.breakpoints.down('sm')]: {
      marginRight: '30px',
    }
  },
  send: {
    width: '120px',
    color: '#fff',
    boxShadow: 'none',
    backgroundColor: '#2ca5ec'
  },
  dateDuration: {
    display: 'flex',
    marginTop: 20,
    marginBottom: 20
  },
  dates: {
    display: 'flex',
  },
  datePicker: {
    marginTop: 10,
    marginRight: 20,
    "& .date-input": {
      border: 'solid 1px #4F576E',
      borderRadius: 2,
      padding: 5
    },
    "& svg": {
      marginRight: 5
    }
  },
  durationInput: {
    marginTop: 10,
    marginRight: 20,
    "& input": {
      padding: '3px 5px',
      border: 'solid 1px #4F576E',
      borderRadius: 2,
      fontSize: '1rem',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 400,
      lineHeight: 1.5,
      letterSpacing: '0.00938em'
    }
  },
  duration: {
    display: 'flex'
  }
}))

export default function WriteComments (props) {

  const {newComments, context} = props
  const hours = Math.floor(props.duration / 3600)
  const minutes = Math.floor(props.duration % 3600 / 60)
  const {translate} = context
  const classes = useStyles()
  const canSave = props.selectedStudents.length > 0 && props.duration > 0

  return (
      <Box className={classes.root}>
        <Box className={classes.dateDuration}>
        <Box className={classes.dates}>
          <Box className="from">
            <label>{translate("start")}</label>
            <Box className={classes.datePicker}>
              <DatePicker
                customInput={<DateInput />}
                locale={context.languageId == 'en' ? dateLocale.enUS : dateLocale.es}
                selected={moment(props.start).toDate()}
                minDate={new Date()}
                maxDate={moment().add(1,'year').toDate()}
                showTimeInput
                dateFormat="MM/dd/yyyy h:mm aa"
                onChange={props.onStartChange}
              />
            </Box>
          </Box>
          <div className="to">
            <label>{translate("end")}</label>
            <Box className={classes.datePicker}>
              <DatePicker
                customInput={<DateInput />}
                locale={context.languageId == 'en' ? dateLocale.enUS : dateLocale.es}
                selected={moment(props.finish).toDate()}
                minDate={moment(props.start).toDate()}
                maxDate={moment().add(1,'year').toDate()}
                showTimeInput
                dateFormat="MM/dd/yyyy h:mm aa"
                timeIntervals={60}
                onChange={props.onFinishChange}
              />
            </Box>
          </div>
        </Box>
        <Box className={classes.duration}>
          <div className="hours">
            <label>{translate("hours")}</label>
            <div className={classes.durationInput}>
              <input type="text" value={hours} onChange={e => {
                const value = parseInt(e.target.value)
                const hours = isNaN(value) ? 0 : value
                props.onTimeChange({hours, minutes})
              }}/>
            </div>
          </div>
          <div className="minutes">
            <label>{translate("minutes")}</label>
            <div className={classes.durationInput}>
              <input type="text" value={minutes} onChange={e => {
                const value = parseInt(e.target.value)
                const minutes = isNaN(value) ? 0 : value
                props.onTimeChange({hours, minutes})
              }} />
            </div>
          </div>
        </Box>
        </Box>
        <Box className={classes.label}>
          <Typography>
            {translate('comment')}
          </Typography>
        </Box>
        <Box className={classes.comments}>
          <textarea autoFocus value={newComments} onChange={props.onCommentsChange} />
        </Box>
        <Box className={classes.buttons}>
          <Button
            onClick={props.onCancel}
            variant="contained"
            className={classes.cancel}
          >
            {translate('cancel')}
          </Button>
          <Button
            onClick={props.onSend}
            disabled={!canSave}
            variant="contained"
            className={classes.send}
          >
            {translate('save_label')}
          </Button>
        </Box>
      </Box>
    )
}
